type Props = {
    size?: string,
    color?: string,
};

/*
 * main collection: https://www.svgrepo.com/collection/brightspace-bold-interface-icons/
 * specific icon: https://www.svgrepo.com/svg/335555/edit
 */
const Editable = ({ size = '16', color = 'black' }: Props) => (
    <svg
        fill={color}
        height={size}
        width={size}
        viewBox="0 0 24 24"
    >
        <path d="M22.707 5.536l-4.243-4.243.707-.707c.782-.78 2.048-.78 2.83 0L23.413 2c.78.78.78 2.047 0 2.828l-.707.708zM17.38 5.208l1.412 1.412-4.586 4.586-2.53 2.53-5.756 5.756L4.852 20l-1.507.656L4 19.15l.51-1.068 5.755-5.756 2.53-2.53 4.585-4.588m0-2.828l-6 6-2.53 2.53-6 6-.67 1.41-2.15 4.94c-.04.12-.04.25 0 .37.04.07.1.13.16.18.05.06.11.12.18.16.06.02.12.03.19.03.06 0 .12-.01.18-.03l4.94-2.15 1.41-.67 6-6 2.53-2.53 6-6-4.24-4.24z" />
    </svg>
)

export default Editable;